import { SFTPUserDTO } from "../DTO/sftpUserDTO";
import { Customer } from "./customer";

export class SFTPUser{
    public id!: number;
    public customerId!: number;
    public customer!: Customer;
    public sftpUsername!: string;
    public sftpPassword!: string;
    public description!: string;
    public enabled!: boolean;
    public added!: Date;
    public edited!: Date;

    public static mapFromDTO(param:SFTPUserDTO):SFTPUser{ 
        if (!param) throw new Error("parameter is null")
        let obj = new SFTPUser();
        try
        {
            obj.id = param.id;
            obj.customerId = param.customerId;
            obj.sftpUsername = param.sftpUsername;
            obj.sftpPassword = param.sftpPassword;
            obj.description = param.description;
            obj.enabled = param.enabled
            if(param.added) obj.added = new Date(param.added);
            if(param.edited) obj.added = new Date(param.edited);
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:SFTPUser):SFTPUserDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new SFTPUserDTO();
        try
        {
            dto.id = param.id;
            dto.customerId = param.customer.id;
            dto.sftpUsername = param.sftpUsername;
            dto.sftpPassword = param.sftpPassword;
            dto.description = param.description;
            dto.enabled = param.enabled;
            if(param.added) dto.added = param.added.toISOString();
            if(param.edited) dto.added = param.edited.toISOString();
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }
}